export const getPostUrl = (com, postNo) => 'http://m.kuaidi100.com/index_all.html?type=' + com + '&postid=' + postNo + '&callbackurl=' + encodeURIComponent(window.location.href) + '#result';
export const getTurntableUrl = (orderId) => 'http://m.wenshendaka.com/turntable/?_id=' + orderId + '&type=order';
export const getShareHBUrl = (orderId) => 'http://m.wenshendaka.com/share_red_packet/?_id=' + orderId + '&type=order';
export const getFirstHBUrl = (phone, amount) => 'http://m.wenshendaka.com/new_user_packet?phone=' + phone + '&amount=' + amount;



// WEBPACK FOOTER //
// ./src/constants.js